import React, { useEffect, useState } from "react";
import "./Services.css";

// Import your service images
import capitalImg from "../assets/img9.jpg";
import leasingImg from "../assets/img10.jpg";
import tenantImg from "../assets/img14.jpg";
import projectImg from "../assets/img17.jpg";
import assetImg from "../assets/img14.jpg";
import facilityImg from "../assets/img9.jpg";
// Import images
import img3 from "../assets/img4.jpg";
import img4 from "../assets/img6.jpeg";
import img5 from "../assets/img7.jpg";
import img6 from "../assets/img20.jpg";
import img7 from "../assets/img24.jpg";

const images = [img3, img4, img5, img6, img7];

const Services = () => {
  const [currentImage, setCurrentImage] = useState(0);

  // Auto slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);

  // Intersection Observer for animations
  useEffect(() => {
    const sections = document.querySelectorAll(".fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );
    sections.forEach((sec) => observer.observe(sec));
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".fade-in");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("show");
        });
      },
      { threshold: 0.2 }
    );
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-page">
      {/* Slideshow */}
      <div className="slideshow-container">
        {images.map((img, i) => (
          <div
            key={i}
            className={`slide-wrapper ${i === currentImage ? "active" : ""}`}
          >
            <img
              src={img}
              alt={`Slide ${i}`}
              className="slide-image"
            />
          </div>
        ))}
      </div>
      <button onClick={() => setCurrentImage((currentImage - 1 + images.length) % images.length)}>‹</button>
      <button onClick={() => setCurrentImage((currentImage + 1) % images.length)}>›</button>
      <div className="dots">
        {images.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === currentImage ? "active" : ""}`}
            onClick={() => setCurrentImage(i)}
          />
        ))}
      </div>
      {/* CONTENT */}
      <div className="services-container">                
        {/* SERVICES SECTIONS */}
        <div className="services-list">

          {/* 1. Capital Markets */}
          <div className="service fade-in">
            <div className="service-image">
              <img src={capitalImg} alt="Capital Markets" />
            </div>
            <div className="service-content">
              <h2>Capital Markets</h2>
              <p>
                With <strong>Venturestone Capital Markets Service</strong>, you gain access to a
                full suite of advisory, brokerage, valuation, and management capabilities. Whether
                buying, selling, or investing, our market insights and expertise ensure optimal
                investment outcomes.
              </p>
              <p>
                Partner with us to maximise your commercial real estate’s value and make data-driven
                investment decisions.
              </p>
            </div>
          </div>

          {/* 2. Commercial Leasing */}
          <div className="service fade-in reverse">
            <div className="service-image">
              <img src={leasingImg} alt="Commercial Leasing" />
            </div>
            <div className="service-content">
              <h2>Commercial Leasing Services in Bengaluru</h2>
              <p>
                Our Commercial Leasing services align with Bengaluru’s dynamic market to deliver
                strategic solutions for landlords and business owners. We help secure top-tier tenants
                and optimise rental returns across office, industrial, and retail sectors.
              </p>
              <p>
                For tenants, our local market intelligence simplifies the leasing process and ensures
                spaces that suit your business goals.
              </p>
            </div>
          </div>

          {/* 3. Tenant Representation */}
          <div className="service fade-in">
            <div className="service-image">
              <img src={tenantImg} alt="Tenant Representation" />
            </div>
            <div className="service-content">
              <h2>Tenant Representation</h2>
              <p>
                Navigating Bengaluru’s competitive commercial real estate landscape is complex.
                Our Tenant Representation services protect your interests by securing ideal spaces
                at favourable terms — from new leases to renewals or relocations.
              </p>
              <p>
                We advocate for your goals, ensuring you save time, mitigate risks, and achieve the
                best outcomes.
              </p>
            </div>
          </div>

          {/* 4. Project Development */}
          <div className="service fade-in reverse">
            <div className="service-image">
              <img src={projectImg} alt="Project Development" />
            </div>
            <div className="service-content">
              <h2>Project Development Services</h2>
              <p>
                From concept to completion, we streamline every stage of your real estate project.
                Whether it’s new construction, redevelopment, or building consultancy, our Project
                Development Services ensure efficiency, sustainability, and cost control.
              </p>
            </div>
          </div>

          {/* 5. Asset Services */}
          <div className="service fade-in">
            <div className="service-image">
              <img src={assetImg} alt="Asset Services" />
            </div>
            <div className="service-content">
              <h2>Asset Services</h2>
              <p>
                <strong>Venturestone’s Asset Services</strong> focus on enhancing the value and
                performance of your real estate portfolio. From proactive maintenance to strategic
                tenant management, we protect your investment and improve operational efficiency.
              </p>
            </div>
          </div>

          {/* 6. Facilities Services */}
          <div className="service fade-in reverse">
            <div className="service-image">
              <img src={facilityImg} alt="Facilities Services" />
            </div>
            <div className="service-content">
              <h2>Facilities Services</h2>
              <p>
                Our Facilities Services guarantee smooth operations for your assets — from daily
                maintenance to emergency repairs. We provide reliable, cost-effective solutions to
                ensure your properties remain safe, efficient, and functional.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Services;
